const API_BASE_ADDRESS = 'http://localhost:4000';

export default class Api {
    static getoutboundData() {
        const uri = API_BASE_ADDRESS + "/outboundData";

        return fetch(uri, {
            method: 'GET'
        });
    }
}